<template>
  <div class="BusinessIntroModel">
    <div class="notification-popup">
      <div class="popup-content">
        <div class="pop-head">
          <img src="../../assets/images/logo-91.svg" alt="" />
        </div>
        <p>
          {{$t('intro')}}
        </p>
        <span class="popup-btn" @click="CloseBusinessIntroModel"
          >{{$t('GototheAdda')}}</span
        >
         <!-- <span class="popup-btn" @click="CloseBusinessIntroModel"
          >अड्डा पर जाये</span
        > -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  name: "BusinessIntroModal",
  components: {},
  props: {},
  data() {
    return {};
  },
  methods: {
    ...mapMutations(["closePopUp"]),
    // CloseBusinessIntroModel() {
    //   document.querySelector("body").classList.remove("BusinessIntro_Body");

// }
    CloseBusinessIntroModel() {
      this.closePopUp(false)

}
  },

  beforeDestroy() {
    // document.querySelector("body").classList.remove("BusinessIntro_Body");
  },
  computed: {},
  mounted() {
    document.querySelector("body").classList.add("BusinessIntro_Body");
  }
};
</script>
<style></style>
